import { SPLIT_TEST_NAME } from './SPLIT_TESTS';
import { useAnonymousSplitTests } from './useAnonymousSplitTests';
import { useLocale } from '../hooks/useLocale';
import { useSignupParams } from '../hooks/useSignupParams';

export type TEmailValidationBranch = 'INCLUDE' | 'EXCLUDE' | undefined;

export function useEmailValidationTest(): {
  branch: TEmailValidationBranch;
  isInTest: boolean;
} {
  const { isUK } = useLocale();
  const { isDirectCustomer } = useSignupParams();

  const splitTests = useAnonymousSplitTests({
    testFilter: SPLIT_TEST_NAME.EMAIL_VALIDATION_AT_SIGNUP_2026,
    enabled: isUK && isDirectCustomer,
  });

  const branchName = splitTests?.[0]?.branch_name;
  const branch =
    branchName === 'INCLUDE' || branchName === 'EXCLUDE'
      ? branchName
      : undefined;

  return { branch, isInTest: branch === 'INCLUDE' };
}
